'use client'

import { useSyncExternalStore } from 'react'

import { Wordmark } from '@/app/(app)/signin/_components/wordmark'

// Hydration-safe localStorage read. Server snapshot is always false; client
// snapshot reads the flag. Mirrors the pattern in appearance-annotation.tsx
// — same canonical fix React 19 wants for "is the client mounted yet" reads
// against ambient browser state.
// eslint-disable-next-line @typescript-eslint/no-empty-function -- useSyncExternalStore requires subscribe to return an unsubscribe function; there is nothing to unsubscribe from here
const subscribeNoop = () => () => {}
const getHasSignedInClient = () =>
    localStorage.getItem('hasAlreadySignedIn') === 'true'
const getHasSignedInServer = () => false

/**
 * Signin header — in-app Wordmark + italic-serif intent line. Two intent
 * variants chosen via the `hasAlreadySignedIn` localStorage flag (single-
 * bit UX hint; not cross-device user data — exempt from no-localStorage
 * rule per spec §10.12).
 *
 * Spec: docs/superpowers/specs/2026-05-13-signin-mini-spec.md §1.1 rows 1-2.
 *
 * The localStorage read flows through useSyncExternalStore so the server-
 * rendered HTML is stable (always the first-time intent) and the client
 * patches in the welcome-back variant after hydration. Reading
 * synchronously in render would otherwise mismatch — masked by the root
 * layout's `suppressHydrationWarning` (which exists for next-themes).
 */
export function Header() {
    const hasAlreadySignedIn = useSyncExternalStore(
        subscribeNoop,
        getHasSignedInClient,
        getHasSignedInServer
    )

    return (
        <div className="flex flex-col items-center gap-6 text-center">
            <Wordmark />
            <p className="max-w-[28ch] font-serif text-base leading-relaxed text-muted-fg italic sm:text-lg">
                {hasAlreadySignedIn
                    ? 'welcome back — continue your journey.'
                    : 'master 2,200 kanji the Heisig way.'}
            </p>
        </div>
    )
}
